import React, { useState, useRef } from 'react';
import { EmojiReaction } from '../types';
import EmojiPicker from './EmojiPicker';

interface EmojiReactionsProps {
  reactions: EmojiReaction[];
  onReaction: (emoji: string) => void;
}

const EmojiReactions: React.FC<EmojiReactionsProps> = ({ 
  reactions, 
  onReaction
}) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const addButtonRef = useRef<HTMLButtonElement>(null);

  const handleEmojiClick = (emoji: string) => {
    onReaction(emoji);
  };

  const handleAddClick = () => {
    setIsPickerOpen(!isPickerOpen);
  };


  return (
    <div className="flex items-center gap-2 flex-wrap" data-emoji-reaction>
      {reactions.map((reaction, index) => (
        <button
          key={`${reaction.emoji}-${index}`}
          onClick={() => handleEmojiClick(reaction.emoji)}
          className="flex items-center gap-1 px-2.5 py-1 rounded-full text-sm bg-gray-100 dark:bg-slate-700/50 text-gray-700 dark:text-slate-300 hover:bg-gray-200 dark:hover:bg-slate-600/50 border border-gray-200/60 dark:border-slate-600/50 transition-colors"
        >
          <span className="text-base">{reaction.emoji}</span>
          <span className="text-xs font-medium">{reaction.count}</span>
        </button>
      ))}
      
      <div className="relative">
        <button
          ref={addButtonRef}
          onClick={handleAddClick}
          className="flex items-center gap-1 px-2.5 py-1 rounded-full text-sm bg-gray-100 dark:bg-slate-700/50 text-gray-500 dark:text-slate-400 hover:bg-gray-200 dark:hover:bg-slate-600/50 border border-gray-200/60 dark:border-slate-600/50 transition-colors"
          title="Add reaction"
        >
          <span className="text-base">+</span>
          <span className="text-sm">😊</span>
        </button>
        
        <EmojiPicker
          isOpen={isPickerOpen}
          onClose={() => setIsPickerOpen(false)}
          onEmojiSelect={handleEmojiClick}
          triggerRef={addButtonRef}
        />
      </div>
    </div>
  );
};

export default EmojiReactions;
